<app-pan-card [header]="'Report Dashboard'" [isPageContainer]="true" [pageContainerSize]="'xl'">
  <div rightActions>
    <app-pan-button-group>
      <app-pan-button
        color="primary"
        [width]="48"
        [fill]="currentView() === 'Mine' ? 'filled' : 'outline'"
        (click)="currentView.set('Mine')"
      >
        Mine ({{ myReportsCount() }})
      </app-pan-button>

      <app-pan-button
        color="primary"
        [width]="48"
        [fill]="currentView() === 'Shared' ? 'filled' : 'outline'"
        (click)="currentView.set('Shared')"
      >
        Shared With Me ({{ sharedReportsCount() }})
      </app-pan-button>
    </app-pan-button-group>
  </div>

  <ag-grid-angular
    data-testid="report-dashboard-table"
    [loading]="isLoading()"
    [rowData]="filteredReports()"
    [columnDefs]="columnDefs"
    [gridOptions]="tableDef"
  ></ag-grid-angular>
</app-pan-card>

<app-pan-modal #viewHistoryModal data-testid="report-history-modal" (modalClose)="clearHistory()">
  <div header>{{ reportHistoryChosenName() }} History</div>

  <div body>
    @if (reportHistoryLoading()) {
      <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> &nbsp;Loading... </app-pan-blank-slate>
    } @else {
      @let historyEntries = reportHistory();

      @if (historyEntries.length === 0) {
        <app-pan-blank-slate>No history available for this report.</app-pan-blank-slate>
      }

      <div class="flex flex-col gap-4 max-h-[400px] overflow-y-auto">
        @for (entry of historyEntries; track $index) {
          <div class="mt-2 border-gray-200 pb-2" [class.border-b-2]="!$last">
            <div class="font-semibold">{{ entry.created_at | date: "medium" }}</div>

            <p data-testid="report-history-entry">Shared with {{ entry.shared_with }} by {{ entry.shared_by }}</p>
          </div>
        }
      </div>
    }
  </div>

  <div footer>
    <button data-testid="report-history-close-button" panModalClose panButton>Close</button>
  </div>
</app-pan-modal>
